<template>
  <v-row align="center">
    <v-col>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="prg.data"
        offset-y
        transition="scale-transition"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dataFormatada"
            label="Data"
            prepend-icon="mdi-calendar"
            v-on="on"
            v-bind="attrs"
            readonly
            :disabled="['A', 'B'].indexOf(situacao) < 0"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="prg.data"
          no-title
          :disabled="['A', 'B'].indexOf(situacao) < 0"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(prg.data)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col>
      <v-text-field
        label="Valor"
        v-mask="'money'"
        v-model="prg.valor"
        :disabled="['A', 'B'].indexOf(situacao) < 0"
      />
    </v-col>
    <v-col>
      <v-switch
        label="Antecipado"
        v-model="prg.antecipado"
        :disabled="['A', 'B'].indexOf(situacao) < 0"
      />
    </v-col>
    <v-col
      cols="2"
      class="text-center"
      v-if="['A', 'B'].indexOf(situacao) > -1"
    >
      <v-btn icon @click="$emit('remove', prg)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
export default {
  props: ["programacao", "situacao"],
  data() {
    return {
      prg: {
        data: this.programacao.data,
        valor: this.programacao.valor,
        antecipado: this.programacao.antecipado,
      },
      menu: false,
    };
  },
  computed: {
    dataFormatada() {
      if (this.prg.data) {
        return moment(this.prg.data).format("DD/MM/YYYY");
      }
      return "";
    },
  },
  watch: {
    prg: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    programacao(val) {
      this.prg.data = val.data;
      this.prg.valor = val.valor;
      this.prg.antecipado = val.antecipado;
    },
  },
};
</script>
